import { readString } from "react-papaparse";

import parseCsv from "./parseCsv";
import type { ParseRow, BuildRow, ValidateRow, UploadRequest, UploadRequestOptions } from "./types";

const UPLOAD_SUCCESS_BODY = "ok";

type ParseOutput = {
  data: string[][];
};

// The react-papaparse types declare only the callback form, but the
// parser returns the result of a string input at once.
const readCsvString = readString as unknown as (csvString: string) => ParseOutput;

type CallbackUpload = (file: UploadRequestOptions["file"]) => void;

const getCustomRequest = <P, T>(
  parse: ParseRow<P>,
  validate: ValidateRow<P>,
  build: BuildRow<P, T>,
  callbackSuccess: (items: T[]) => void,
  callbackUpload?: CallbackUpload,
): UploadRequest => {
  const uploadRequest: UploadRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      const hasCallbackUpload = !!callbackUpload;

      if (hasCallbackUpload) {
        callbackUpload(file);
      }

      const reader = new FileReader();

      reader.onload = () => {
        const text = reader.result as string;

        const { data } = readCsvString(text.trim());
        const items = parseCsv(data, parse, validate, build);

        callbackSuccess(items);
      };

      // The upload input hands a file object to the request; the string
      // form of the option is for the remote mode of the input.
      reader.readAsText(file as Blob);
      onSuccess(UPLOAD_SUCCESS_BODY);
    }, 0);
  };

  return uploadRequest;
};

export default getCustomRequest;
